import { FULL_DECK_CORE } from '../derived/full-deck';
import { buildCardDiscoveryMetadata } from '../internal/library-builders';
import { uniq } from '../internal/shared';

export interface CardSearchIndexEntry {
  card_id: number;
  slug: string;
  name: string;
  arcana: 'major' | 'minor';
  suit: string | null;
  rank: string | null;
  element: string;
  tags: string[];
  search_tokens: string[];
  filters: {
    has_lilith: boolean;
    has_decan: boolean;
    has_qliphah: boolean;
    has_hebrew: boolean;
  };
}

export const CARD_SEARCH_INDEX: CardSearchIndexEntry[] = FULL_DECK_CORE.map((card) => {
  const discovery = buildCardDiscoveryMetadata(card);

  return {
    card_id: card.id,
    slug: card.slug,
    name: card.name,
    arcana: card.arcana,
    suit: card.suit,
    rank: card.rank,
    element: card.element,
    tags: uniq(discovery.theme_tags.map((tag) => tag.toLowerCase())),
    search_tokens: uniq(discovery.search_tokens.map((token) => token.toLowerCase())),
    filters: {
      has_lilith: card.lilith_voice.trim().length > 0,
      has_decan: card.decan !== null,
      has_qliphah: card.qliphah !== null || card.lilith_qliphah_link !== null,
      has_hebrew: card.hebrew_letter !== null,
    },
  };
});
